import size from 'lodash/size';
import { browserHistory } from 'react-router';

import { APPOINTMENT_INSPECTION } from '../../constants';
import {
  APPOINTMENT_FORM,
  APPOINTMENT_FORM_USERS,
  APPOINTMENT_FORM_PHARMACY,
  APPOINTMENT_FORM_VISIT_TYPE,
  APPOINTMENT_FORM_HEALTH_INFO,
  APPOINTMENT_FORM_VISIT_SERVICES,
  APPOINTMENT_FORM_CONSENT_FORM,
  APPOINTMENT_FORM_PATIENT_INFO,
  APPOINTMENT_FORM_PAYMENT,
  APPOINTMENT_FORM_SUMMARY,
  APPOINTMENT_FORM_VISIT_DETAILS,
  DEPENDENT_FORM,
  DEPENDENT_FORM_ROLE,
  APPOINTMENT_FORM_PROVIDERS,
  APPOINTMENT_FORM_PROVIDER_DETAILS,
  APPOINTMENT_FORM_OVERVIEW,
  HEALTHBOARD,
  HEALTHBOARD_HOME,
  HEALTHBOARD_EMPTY,
  APPOINTMENT_FORM_ORGANIZATIONS,
  PROFILE,
  PROFILE_SETTINGS,
  CHOOSE_ADD_ACCOUNT,
  LOGIN,
  APPOINTMENT_FORM_VISIT_LOCATIONS,
  APPOINTMENT_FORM_PUBLIX_INFO,
  APPOINTMENT_FORM_AVAILABLE_TIME_SLOTS,
  APPOINTMENT_FORM_MY_PROVIDERS,
  APPOINTMENT_FORM_HEALTH_INFO_PROVIDER,
  APPOINTMENT_FORM_EMERGENCY_CONTACT,
  APPOINTMENT_FORM_INSURANCE_FORM,
  APPOINTMENT_ADDITIONAL_INFO,
  APPOINTMENT_FORM_GUARANTOR_INFORMATION,
} from '../../constants/routes';

export const rootAppointmentFormPath = `${APPOINTMENT_FORM}/${APPOINTMENT_FORM_USERS}`;

export function redirectToUsers(id, replace = true) {
  const suffix = typeof id === 'number' ? `#${id}` : '';
  const path = `${APPOINTMENT_FORM}/${APPOINTMENT_FORM_USERS}${suffix}`;
  const redirect = replace ? browserHistory.replace : browserHistory.push;
  redirect(path);
}

export function redirectToPharmacy() {
  browserHistory.replace(`${APPOINTMENT_FORM}/${APPOINTMENT_FORM_PHARMACY}`);
}

export function redirectToMyProviders() {
  browserHistory.replace(
    `${APPOINTMENT_FORM}/${APPOINTMENT_FORM_MY_PROVIDERS}`,
  );
}

export function redirectToLogIn() {
  browserHistory.replace(`${LOGIN}`);
}

export function redirectToFullInsuranceForm() {
  browserHistory.replace(
    `${APPOINTMENT_FORM}/${APPOINTMENT_FORM_INSURANCE_FORM}`,
  );
}

export function redirectToHealthInfo() {
  browserHistory.replace(`${APPOINTMENT_FORM}/${APPOINTMENT_FORM_HEALTH_INFO}`);
}

export function redirectToHealthInfoProvider() {
  browserHistory.replace(
    `${APPOINTMENT_FORM}/${APPOINTMENT_FORM_HEALTH_INFO_PROVIDER}`,
  );
}

export function redirectToPayment() {
  browserHistory.replace(`${APPOINTMENT_FORM}/${APPOINTMENT_FORM_PAYMENT}`);
}

export function redirectToSummary() {
  browserHistory.replace(`${APPOINTMENT_FORM}/${APPOINTMENT_FORM_SUMMARY}`);
}

export function redirectToOrganizations() {
  browserHistory.replace(
    `${APPOINTMENT_FORM}/${APPOINTMENT_FORM_ORGANIZATIONS}`,
  );
}

export function redirectToVisitType() {
  browserHistory.replace(`${APPOINTMENT_FORM}/${APPOINTMENT_FORM_VISIT_TYPE}`);
}

export function redirectToEmergencyContact() {
  browserHistory.replace(
    `${APPOINTMENT_FORM}/${APPOINTMENT_FORM_EMERGENCY_CONTACT}`,
  );
}

export function redirectToServices() {
  browserHistory.replace(
    `${APPOINTMENT_FORM}/${APPOINTMENT_FORM_VISIT_SERVICES}`,
  );
}

export function redirectToLocations() {
  browserHistory.replace(
    `${APPOINTMENT_FORM}/${APPOINTMENT_FORM_VISIT_LOCATIONS}`,
  );
}

export function redirectToPublixInfo() {
  browserHistory.replace(`${APPOINTMENT_FORM}/${APPOINTMENT_FORM_PUBLIX_INFO}`);
}
export function redirectBackToServiceOrVisitType(services) {
  if (size(services) > 1) {
    redirectToServices();
  } else redirectToVisitType();
}

export function redirectToConsentForm() {
  browserHistory.replace(
    `${APPOINTMENT_FORM}/${APPOINTMENT_FORM_CONSENT_FORM}`,
  );
}

export function redirectToPatientForm() {
  browserHistory.replace(
    `${APPOINTMENT_FORM}/${APPOINTMENT_FORM_PATIENT_INFO}`,
  );
}

export function redirectToVisitDetails() {
  browserHistory.replace(
    `${APPOINTMENT_FORM}/${APPOINTMENT_FORM_VISIT_DETAILS}`,
  );
}

export function redirectToGuarantorInformation() {
  browserHistory.replace(
    `${APPOINTMENT_FORM}/${APPOINTMENT_FORM_GUARANTOR_INFORMATION}`,
  );
}

export function redirectToAdditionalInformation() {
  browserHistory.replace(`${APPOINTMENT_FORM}/${APPOINTMENT_ADDITIONAL_INFO}`);
}

export function redirectToProviders() {
  browserHistory.replace(`${APPOINTMENT_FORM}/${APPOINTMENT_FORM_PROVIDERS}`);
}

export function redirectToProviderDetails() {
  browserHistory.replace(
    `${APPOINTMENT_FORM}/${APPOINTMENT_FORM_PROVIDER_DETAILS}`,
  );
}

export function redirectToAppointmentOverview() {
  browserHistory.replace(`${APPOINTMENT_FORM}/${APPOINTMENT_FORM_OVERVIEW}`);
}

export function redirectToDependentForm() {
  browserHistory.replace(`${DEPENDENT_FORM}/${DEPENDENT_FORM_ROLE}`);
}

export function redirectToHealthBoard(id) {
  browserHistory.replace(`${HEALTHBOARD}/${id}/${HEALTHBOARD_HOME}`);
}

export function redirectToHealthBoardEmpty() {
  browserHistory.push(`${HEALTHBOARD_EMPTY}`);
}

export function redirectToSettings(id) {
  browserHistory.push(`${PROFILE}/${id}/${PROFILE_SETTINGS}`);
}

export function redirectToAddAccount() {
  browserHistory.push(`${CHOOSE_ADD_ACCOUNT}`);
}

export function redirectToStep(step, services) {
  switch (step) {
    case APPOINTMENT_INSPECTION.PROFILE:
      return redirectToPatientForm();
    case APPOINTMENT_INSPECTION.DOCUMENTS:
      return redirectToPatientDocuments();
    default:
      return redirectBackToServiceOrVisitType(services);
  }
}

export function redirectToAvailableTimeSlots() {
  browserHistory.replace(
    `${APPOINTMENT_FORM}/${APPOINTMENT_FORM_AVAILABLE_TIME_SLOTS}`,
  );
}

export function redirectToRescheduleProviderDetails({
  locationId,
  providerId,
}) {
  const redirectDetailsPath = `${APPOINTMENT_FORM}/${APPOINTMENT_FORM_PROVIDER_DETAILS.replace(
    ':id',
    providerId,
  )}#${locationId}`;
  browserHistory.replace(redirectDetailsPath);
}



// WEBPACK FOOTER //
// ./src/utils/appointments/redirect-utils.js